export const socialNetworks = [
    {
        name: 'Facebook',
        key: 'facebook',
        url: 'facebook.com'
    },
    {
        name: 'Instagram',
        key: 'instagram',
        url: 'instagram.com'
    },
    {
        name: 'LinkedIn',
        key: 'linkedin',
        url: 'linkedin.com'
    }
] as const
